import { environment } from "@/environments/environment";
import {HttpClient, HttpResponse} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OrderShipping, SearchOrderShippingCommand } from "../interface/order-shipping.interface";
import {Observable} from "rxjs";

@Injectable({
  providedIn: "root",
})
export class OrderShippingService {

  constructor(private http: HttpClient) { }

  searchOrderShipping(body: SearchOrderShippingCommand) {
    return this.http.post<OrderShipping[]>(`${environment.baseURL}order/order-shipping/user`, body, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  downloadShipmentPdf(orderId: string) {
    return this.http.get(`${environment.baseURL}order/order-shipping/shipment-pdf/${encodeURIComponent(orderId)}`, {
      responseType: 'blob'
    });
  }

  exportShipmentExcel(orderId: string, shipmentId?: number) : Observable<HttpResponse<Blob>> {
    let url = `${environment.baseURL}order/order-shipping/export-excel/${encodeURIComponent(orderId)}`;
    if (shipmentId) {
      url += `?shipmentId=${shipmentId}`;
    }
    return this.http.get(url, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
